import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteHeader, SiteFooter } from './Layout';
import MonthlyDividendETFs from './MonthlyDividendETFs'; // 신규 컴포넌트 import

const FEED_GLASS = {
  background: 'rgba(255,255,255,0.06)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid rgba(255,255,255,0.12)',
};

function ArticlesFeed() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const FEED_URL = 'https://www.swn.kr/category/news/economy/feed';
    fetch('https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(FEED_URL))
      .then(res => res.json())
      .then(data => {
        if (data.status !== 'ok') throw new Error('feed error');
        setArticles(data.items.slice(0, 5).map(item => {
          const tmp = document.createElement('div');
          tmp.innerHTML = item.description || '';
          const raw = (tmp.textContent || '').trim().replace(/\s+/g, ' ');
          // WordPress 자동 생성 "The post ... appeared first on ..." 제거
          const clean = raw.replace(/The post\s.+?appeared first on\s.+?\.\s*$/, '').trim();
          const excerpt = clean.slice(0, 130) + (clean.length > 130 ? '…' : '');
          return {
            title: item.title,
            link: item.link,
            excerpt,
            categories: (item.categories || []).slice(0, 3),
            pubDate: item.pubDate,
            author: item.author || '',
          };
        }));
        setLoading(false);
      })
      .catch(() => {
        setError('피드를 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.');
        setLoading(false);
      });
  }, []);

  const formatDate = str => {
    try {
      return new Date(str).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch { return ''; }
  };

  if (loading) return (
    <div className="flex justify-center py-16">
      <div className="text-center" style={{ color: 'rgba(255,255,255,0.4)' }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
        <p className="text-sm">기사를 불러오는 중...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="text-center py-10 rounded-3xl" style={FEED_GLASS}>
      <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>{error}</p>
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      {articles.map((article, i) => (
        <a
          key={i}
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className="block rounded-3xl p-6 transition-all no-underline"
          style={FEED_GLASS}
          onMouseEnter={e => {
            e.currentTarget.style.border = '1px solid rgba(255,255,255,0.28)';
            e.currentTarget.style.transform = 'translateX(6px)';
            e.currentTarget.style.background = 'rgba(255,255,255,0.09)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.border = '1px solid rgba(255,255,255,0.12)';
            e.currentTarget.style.transform = '';
            e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
          }}
        >
          {/* 상단: 카테고리 + 날짜 */}
          <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
            <div className="flex flex-wrap gap-2">
              {article.categories.length > 0
                ? article.categories.map((cat, j) => (
                    <span key={j} className="text-xs font-bold px-2 py-0.5 rounded-full"
                      style={{ background: 'rgba(59,130,246,0.2)', color: '#93c5fd', border: '1px solid rgba(59,130,246,0.3)' }}>
                      {cat}
                    </span>
                  ))
                : (
                    <span className="text-xs font-bold px-2 py-0.5 rounded-full"
                      style={{ background: 'rgba(16,185,129,0.2)', color: '#6ee7b7', border: '1px solid rgba(16,185,129,0.3)' }}>
                      경제
                    </span>
                  )
              }
            </div>
            {article.pubDate && (
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>
                {formatDate(article.pubDate)}
              </span>
            )}
          </div>

          {/* 제목 */}
          <h4 className="font-bold text-base leading-snug mb-2 text-white">
            {article.title}
          </h4>

          {/* 내용 요약 */}
          {article.excerpt && (
            <p className="text-sm leading-relaxed mb-4" style={{ color: 'rgba(255,255,255,0.5)' }}>
              {article.excerpt}
            </p>
          )}

          {/* 바로가기 */}
          <span className="text-sm font-bold" style={{ color: '#60a5fa' }}>
            기사 읽기 →
          </span>
        </a>
      ))}
    </div>
  );
}

function LandingPage() {
  const glassCard = {
    background: 'rgba(255,255,255,0.06)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.12)',
  };

  const glassCardAccent = (from, to) => ({
    background: `linear-gradient(135deg, ${from}, ${to})`,
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.15)',
  });

  return (
    <div className="min-h-screen text-white overflow-x-hidden" style={{ background: '#060c1a' }}>

      {/* ── 배경 장식 orb ── */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
        <div style={{ position:'absolute', top:'-15%', left:'-8%', width:640, height:640, borderRadius:'50%', background:'rgba(59,130,246,0.18)', filter:'blur(120px)' }} />
        <div style={{ position:'absolute', top:'35%', right:'-10%', width:520, height:520, borderRadius:'50%', background:'rgba(99,102,241,0.14)', filter:'blur(100px)' }} />
        <div style={{ position:'absolute', bottom:'-5%', left:'25%', width:440, height:440, borderRadius:'50%', background:'rgba(6,182,212,0.10)', filter:'blur(90px)' }} />
      </div>

      <SiteHeader />

      {/* ════════════ HERO ════════════ */}
      <section className="relative flex flex-col items-center justify-center text-center px-6 pt-24 pb-16"
        style={{ zIndex: 10, minHeight: '100vh' }}>
        <span className="inline-block text-xs font-bold px-4 py-1.5 rounded-full mb-6"
          style={{ background: 'rgba(16,185,129,0.15)', color: '#34d399', border: '1px solid rgba(16,185,129,0.3)' }}>
          2024년 최신 개정 세법 완벽 반영
        </span>

        <h1 className="font-black leading-tight max-w-3xl mb-6" style={{ fontSize: 'clamp(2.2rem, 5vw, 4rem)', lineHeight: 1.15 }}>
          복잡한 절세 전략,<br />
          <span style={{ background: 'linear-gradient(90deg,#60a5fa,#a5b4fc,#67e8f9)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            데이터로 단순하게
          </span>
        </h1>

        <p className="text-lg max-w-lg mb-10 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
          ISA · 연금저축 · IRP 3총사를 하나의 플랫폼에서.<br />
          지식을 넘어 행동으로, 수익으로.
        </p>

        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/simulator" className="no-underline font-black px-8 py-4 rounded-2xl text-base transition-all"
            style={{ background: 'linear-gradient(135deg,#3b82f6,#6366f1)', color: '#fff', boxShadow: '0 0 32px rgba(99,102,241,0.4)' }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
            onMouseLeave={e => e.currentTarget.style.transform = ''}>
            Actionable Data 확인하기
          </Link>
          <a href="#products" className="no-underline font-bold px-8 py-4 rounded-2xl text-base transition-all"
            style={{ ...glassCard, color: '#fff' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}>
            더 알아보기
          </a>
        </div>

        {/* 스크롤 힌트 */}
        <div className="absolute bottom-10 left-1/2 flex flex-col items-center gap-2"
          style={{ transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.25)', fontSize: 10, animation: 'bounce 2s infinite' }}>
          <span className="font-bold tracking-widest">SCROLL</span>
          <div style={{ width: 1, height: 32, background: 'rgba(255,255,255,0.2)' }} />
        </div>
      </section>

      {/* ════════════ BENTO GRID ════════════ */}
      <section id="products" className="relative px-6 py-20 max-w-6xl mx-auto" style={{ zIndex: 10 }}>
        <p className="text-center font-bold text-xs tracking-widest mb-2" style={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase' }}>왜 3총사인가?</p>
        <h2 className="text-center font-black mb-12" style={{ fontSize: '2rem' }}>
          각 계좌의 <span style={{ color: '#60a5fa' }}>핵심 혜택</span>
        </h2>

        {/* Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

          {/* IRP — wide */}
          <div className="rounded-3xl p-7 md:p-8 flex flex-col justify-between md:col-span-2" style={{ ...glassCard, minHeight: 200 }}>
            <div>
              <span className="inline-block text-xs font-bold px-3 py-1 rounded-full mb-4"
                style={{ background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', border: '1px solid rgba(99,102,241,0.3)' }}>
                🛡️ IRP · 개인형 퇴직연금
              </span>
              <h3 className="text-2xl font-black mb-2">가장 강력한 세액공제 수단</h3>
              <p className="text-sm leading-relaxed mb-3" style={{ color: 'rgba(255,255,255,0.55)' }}>
                퇴직금과 추가 납입을 통합 관리. 소득이 있는 모든 취업자 · 자영업자가 활용 가능.
              </p>
              {/* IRP 월배당 시너지 문구 추가 */}
              <a href="#" className="text-sm font-bold no-underline" style={{ color: '#a5b4fc' }}>
                월배당 재투자 시 과세이연으로 복리효과 극대화 가이드 →
              </a>
            </div>
            <div className="flex gap-8 mt-6">
              <div>
                <p className="text-3xl font-black" style={{ color: '#a5b4fc' }}>900만원</p>
                <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>최대 세액공제</p>
              </div>
              <div>
                <p className="text-3xl font-black" style={{ color: '#a5b4fc' }}>1,800만원</p>
                <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>연간 납입 한도</p>
              </div>
            </div>
          </div>

          {/* 절세 합산 stat */}
          <div className="rounded-3xl p-8 flex flex-col justify-between" style={{ ...glassCardAccent('rgba(59,130,246,0.22)','rgba(99,102,241,0.22)'), minHeight: 220 }}>
            <p className="text-sm font-bold" style={{ color: 'rgba(255,255,255,0.55)' }}>3총사 합산 최대 절세</p>
            <div>
              <p className="font-black mt-3" style={{ fontSize: '3rem', lineHeight: 1.1 }}>148만원</p>
              <p className="text-xs mt-2" style={{ color: 'rgba(255,255,255,0.4)' }}>연간 기준 · 세율 16.5% 적용 추정</p>
            </div>
            <div className="mt-4 rounded-full overflow-hidden" style={{ height: 4, background: 'rgba(255,255,255,0.1)' }}>
              <div style={{ width: '82%', height: '100%', background: 'linear-gradient(90deg,#3b82f6,#67e8f9)', borderRadius: 9999 }} />
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

          {/* 연금저축 */}
          <div className="rounded-3xl p-8 flex flex-col justify-between" style={glassCard}>
            <div>
              <span className="inline-block text-xs font-bold px-3 py-1 rounded-full mb-4"
                style={{ background: 'rgba(16,185,129,0.2)', color: '#6ee7b7', border: '1px solid rgba(16,185,129,0.3)' }}>
                📈 연금저축
              </span>
              <h3 className="text-xl font-black mb-2">연금저축펀드</h3>
              <p className="text-sm leading-relaxed mb-3" style={{ color: 'rgba(255,255,255,0.55)' }}>
                노후 준비와 연말정산 혜택을 동시에. 누구나 가입 가능.
              </p>
               {/* 연금저축 월배당 시너지 문구 추가 */}
              <a href="#" className="text-sm font-bold no-underline" style={{ color: '#6ee7b7' }}>
                월배당 재투자 복리효과 가이드 →
              </a>
            </div>
            <p className="text-2xl font-black mt-4" style={{ color: '#6ee7b7' }}>
              600만원 <span className="text-sm font-normal" style={{ color: 'rgba(255,255,255,0.4)' }}>세액공제</span>
            </p>
          </div>

          {/* ISA */}
          <div className="rounded-3xl p-8 flex flex-col justify-between" style={glassCard}>
            <div>
              <span className="inline-block text-xs font-bold px-3 py-1 rounded-full mb-4"
                style={{ background: 'rgba(59,130,246,0.2)', color: '#93c5fd', border: '1px solid rgba(59,130,246,0.3)' }}>
                💼 ISA
              </span>
              <h3 className="text-xl font-black mb-2">중개형 ISA</h3>
              <p className="text-sm leading-relaxed mb-3" style={{ color: 'rgba(255,255,255,0.55)' }}>
                비과세 + 저율 분리과세. 손익통산으로 실질 수익률 극대화.
              </p>
              {/* ISA 월배당 시너지 문구 추가 */}
              <a href="#" className="text-sm font-bold no-underline" style={{ color: '#93c5fd' }}>
                미국배당 ETF 투자 시 절세 혜택 →
              </a>
            </div>
            <p className="text-2xl font-black mt-4" style={{ color: '#93c5fd' }}>
              400만원 <span className="text-sm font-normal" style={{ color: 'rgba(255,255,255,0.4)' }}>비과세 한도</span>
            </p>
          </div>

          {/* ISA→연금 전환 시너지 */}
          <div id="synergy" className="rounded-3xl p-8 flex flex-col justify-center items-center text-center"
            style={glassCardAccent('rgba(16,185,129,0.18)','rgba(59,130,246,0.18)')}>
            <span style={{ fontSize: '2.5rem' }}>⚡</span>
            <h3 className="text-lg font-black mt-3 mb-2">ISA → 연금 전환</h3>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
              만기 자금 연금 전환 시<br />
              <strong className="text-white">추가 300만원 공제</strong>
            </p>
          </div>
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

          {/* 시너지 전략 — wide */}
          <div className="rounded-3xl p-8 md:col-span-2" style={glassCard}>
            <p className="text-xs font-bold tracking-widest mb-3" style={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase' }}>3총사 시너지</p>
            <h3 className="text-2xl font-black mb-5">각각이 아닌, 함께 쓸 때 극대화</h3>
            <div className="flex items-center gap-3 flex-wrap mb-5">
              {[['IRP','rgba(99,102,241,0.3)','#a5b4fc'],['+','','#3b82f6'],['연금저축','rgba(16,185,129,0.3)','#6ee7b7'],['+','','#3b82f6'],['ISA','rgba(59,130,246,0.3)','#93c5fd'],['=','','#60a5fa'],['최대 절세','linear-gradient(135deg,#3b82f6,#06b6d4)','#fff']].map(([label, bg, color], i) => (
                ['+','='].includes(label)
                  ? <span key={i} className="text-2xl font-black" style={{ color }}>{label}</span>
                  : <span key={i} className="px-4 py-2 rounded-xl font-bold text-sm" style={{ background: bg, color, border: bg.startsWith('linear') ? 'none' : `1px solid ${color}40` }}>{label}</span>
              ))}
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
              납입액, 공제 한도, 예상 수익률을 입력하면 최적의 포트폴리오 조합을 추천해 드립니다.
            </p>
          </div>

          {/* CTA 카드 */}
          <div className="rounded-3xl p-8 flex flex-col justify-between"
            style={glassCardAccent('rgba(59,130,246,0.3)','rgba(99,102,241,0.3)')}>
            <div>
              <p className="text-sm mb-2" style={{ color: 'rgba(255,255,255,0.7)' }}>지금 바로 시작하세요</p>
              <h3 className="text-2xl font-black mb-3">내 맞춤 전략 찾기</h3>
              <p className="text-sm" style={{ color: 'rgba(255,255,255,0.55)' }}>로그인 없이 바로 확인 가능</p>
            </div>
            <Link to="/simulator"
              className="mt-6 block text-center font-black py-3 rounded-xl text-sm no-underline transition-all"
              style={{ background: '#fff', color: '#3730a3' }}
              onMouseEnter={e => e.currentTarget.style.background = '#ede9fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              분석기 열기 →
            </Link>
          </div>
        </div>
        
        {/* 신규: 월배당 ETF 섹션 */}
        <MonthlyDividendETFs />

      </section>

      {/* ════════════ ARTICLES ════════════ */}
      <section id="articles" className="relative px-6 py-16 max-w-3xl mx-auto" style={{ zIndex: 10 }}>
        <p className="text-center font-bold text-xs tracking-widest mb-2" style={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase' }}>Insights</p>
        <h2 className="text-center font-black mb-2" style={{ fontSize: '2rem' }}>투자의 맥을 짚는 기사들</h2>
        <p className="text-center text-sm mb-10" style={{ color: 'rgba(255,255,255,0.35)' }}>
          출처: <a href="https://www.swn.kr/category/news/economy" target="_blank" rel="noopener noreferrer"
            style={{ color: '#60a5fa', textDecoration: 'none' }}>수완뉴스 경제팀</a>
        </p>
        <ArticlesFeed />
      </section>

      <SiteFooter />
    </div>
  );
}

export default LandingPage;
